// extracted by mini-css-extract-plugin
module.exports = {"postSidebar":"postSidebar-module--postSidebar--HcKc3","postSidebarLogo":"postSidebar-module--postSidebarLogo--1ohvc"};